package com.daytimegaming.ourdailyfinances.presentation.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.navigation3.runtime.NavBackStack
import androidx.navigation3.runtime.NavKey
import kotlinx.browser.window

actual fun getInitialWebRoute(): AppRoute? {
    val hash = window.location.hash
    return if (hash.isNotEmpty()) pathToRoute(hash) else AppRoute.Landing
}

actual fun triggerBrowserBack(count: Int): Boolean {
    window.history.go(-count)
    return true
}

@Composable
actual fun BrowserNavigationSync(backStack: NavBackStack<NavKey>, isAuthenticated: Boolean) {
    val currentRoute = backStack.lastOrNull() as? AppRoute
    
    // Sync Compose -> Browser URL
    LaunchedEffect(currentRoute) {
        if (currentRoute != null && currentRoute !is AppRoute.Splash) {
            val targetPath = "#" + routeToPath(currentRoute)
            if (window.location.hash != targetPath) {
                window.location.hash = targetPath
            }
        }
    }

    // Sync Browser URL (Back/Forward/Direct input) -> Compose backStack
    DisposableEffect(backStack, isAuthenticated) {
        val onHashChange: (dynamic) -> Unit = {
            val hash = window.location.hash
            var targetRoute = pathToRoute(hash)
            
            // Map Login/Register to Landing if already authenticated
            if (isAuthenticated && (targetRoute is AppRoute.Login || targetRoute is AppRoute.Register)) {
                targetRoute = AppRoute.Landing
            }

            // Map protected routes to Landing if not authenticated
            if (!isAuthenticated && targetRoute != null &&
                targetRoute !is AppRoute.Splash &&
                targetRoute !is AppRoute.Landing &&
                targetRoute !is AppRoute.Login &&
                targetRoute !is AppRoute.Register &&
                targetRoute !is AppRoute.PrivacyPolicy &&
                targetRoute !is AppRoute.TermsOfService
            ) {
                targetRoute = AppRoute.Landing
            }

            if (targetRoute != null && targetRoute != backStack.lastOrNull()) {
                val existingIndex = backStack.indexOf(targetRoute)
                if (existingIndex != -1) {
                    while (backStack.lastOrNull() != targetRoute) {
                        backStack.removeLastOrNull()
                    }
                } else {
                    backStack.add(targetRoute)
                }
            }
        }
        window.addEventListener("hashchange", onHashChange)

        onDispose {
            window.removeEventListener("hashchange", onHashChange)
        }
    }
}
